// scan qr code

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty, get, isEqual, cloneDeep, toLower, orderBy } from 'lodash';
import { Sidebar } from 'semantic-ui-react';
import qs from 'qs';

import asyncRoute from '../../helpers/hoc/asyncRoute';
import routes from '../../routes';
import {
  analyticsVendorType,
  apiResponseCodes,
  fudrThemeColor,
  geoLocationConfig,
  permissionStatus,
  storageTypes,
  toastMessageTime,
} from '../../constants/globals';
import {
  generateUUID,
  toTitleCase,
  isIOS,
  fetchGeoLocation,
  checkDistanceBetweenCoordinates,
  isNativeWebView,
} from '../../utils/helpers';
import { constants, businessWebsiteUrl } from '../../constants/configuration';
import {
  invalidateRestaurantDataAction,
  clearViewCartItems,
  clearRequestedTimeStampAction,
  fetchRestaurantListAction,
  dispatchPreviousSelectedTableAction,
  dispatchVerifiedLocalitiesAction,
  dispatchSelectedAddressAction,
  dispatchGuestLocationAction,
  clearRestaurantGroupDataAction,
  dispatchParentRouteAction,
  beginAjaxCallAction,
  endAjaxCallAction,
  dispatchUserCartAction,
  findGuestLocationAction,
  findGeoLocationAction,
} from '../../actions/app.action';
import {
  signInByTrueCallerAction,
  dispatchGuestLoginDataAction,
} from '../../actions/authentication';
import {
  selectMenu,
  selectRestaurant,
  getServiceTypeCode,
  getTrueCallerDeepLink,
  getTrueCallerErrorContent,
} from '../../selectors';
import {
  fudrAnalyticsGTMEventCategory,
  fudrAnalyticsGTMEventLabel,
  fudrAnalyticsGTMEvents,
} from '../../utils/FudrAnalytics/config';
import { getItem, setItem } from '../../utils/storage';
import orderingRoutes from '../../routes/ordering';
import hamburgerIcon from '../../assets/images/icons/menu-hamburger.svg';
import closeIcon from '../../assets/images/icons/close.svg';
import scanImageIcon from '../../assets/images/scanImage.svg';
import fudrIcon from '../../assets/images/icons/fudr.svg';
import './Scan.scss';

const Banner = asyncRoute(() => import('../../components/elements/Banner'));
const ScanQR = asyncRoute(() => import('../../components/ScanQR'));
const Drawer = asyncRoute(() => import('../../components/Drawer'));
const Button = asyncRoute(() => import('../../components/elements/Button'));
const AuthenticationPopup = asyncRoute(() => import('../../components/Popup/AuthenticationPopup'));
const Tabs = asyncRoute(() => import('../../components/Tabs'));
const Search = asyncRoute(() => import('../../components/Search'));
const RestaurantList = asyncRoute(() => import('../../components/RestaurantList'));
const DropDown = asyncRoute(() => import('../../components/elements/DropDown'));
const SelectCityPopup = asyncRoute(() => import('../../components/Popup/SelectCity'));
const TellUsPopup = asyncRoute(() => import('../../components/Popup/TellUsPopup'));
const ExceptionComponent = asyncRoute(() => import('../../components/ExceptionComponent'));
const Toast = asyncRoute(() => import('../../components/elements/Toast'));
const PermissionEvent = asyncRoute(() => import('../../utils/FudrAnalytics/permissionEvent'));

const authenticationConfig = constants.authentication;

class Scan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      banner: {
        position: 'top',
        color: fudrThemeColor,
      },
      activeTab: 'scan-qr',
      visible: false,
      scanned: false,
      showScanQRComponent: false,
      showAuthenticationPopup: false,
      showSelectCityPopup: false,
      showTellUsPopup: false,
      searchValue: '',
      restaurantList: [],
      selectedCity: !isEmpty(props.guestLocation) ? props.guestLocation : constants.defaultCity,
      showErrorPopup: false,
      errorContent: {
        title: '',
        description: '',
        buttonCta: '',
      },
      handleErrorCTA: null,
      toast: '',
      geoLocationPermissionStatus: '',
      trackAnalyticEvent: false,
    };
    this.onCloseAuthenticationPopup = this.onCloseAuthenticationPopup.bind(this);
    this.onCloseSelectCityPopup = this.onCloseSelectCityPopup.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  componentDidMount() {
    const {
      invalidateRestaurantDataAction,
      clearRestaurantGroupDataAction,
      clearViewCartItems,
      clearRequestedTimeStampAction,
      dispatchPreviousSelectedTableAction,
      dispatchVerifiedLocalitiesAction,
      dispatchSelectedAddressAction,
      dispatchUserCart,
      location,
    } = this.props;
    invalidateRestaurantDataAction();
    clearRestaurantGroupDataAction();
    clearRequestedTimeStampAction();
    dispatchPreviousSelectedTableAction();
    dispatchVerifiedLocalitiesAction();
    dispatchSelectedAddressAction();
    // clear user's cart data
    dispatchUserCart({});
    clearViewCartItems();

    // get location on App load
    if (!isNativeWebView) {
      fetchGeoLocation(this.geoLocationCallback);
    }

    //  check geolocation permission
    this.checkGeoLocationPermission();

    if (!isEmpty(get(location, 'search'))) {
      const parsed = qs.parse(get(location, 'search', {}));
      if (!isEqual(parsed)) {
        this.setState(
          {
            activeTab: parsed.activeTab,
          },
          () => {
            this.handleTabChange(parsed.activeTab);
          },
        );
      }
    }
    this.props.dispatchParentRouteAction(location.pathname);
  }

  componentWillReceiveProps(nextProps) {
    if (
      !isEqual(get(this.props, 'loginData'), get(nextProps, 'loginData')) &&
      !isEmpty(get(nextProps, 'loginData'))
    ) {
      this.setState({
        showAuthenticationPopup: false,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { toast } = this.state;
    // Change the selected city based on the changes in the guestLocation which populates when the App's mount
    if (
      !isEmpty(this.props.guestLocation) &&
      !isEqual(this.props.guestLocation, prevProps.guestLocation)
    ) {
      this.setState({
        selectedCity: get(this.props, 'guestLocation', constants.defaultCity),
      });
    }

    // Generic toast state
    if (!isEmpty(toast) && !isEqual(toast, prevState.toast)) {
      setTimeout(
        () =>
          this.setState({
            toast: '',
          }),
        toastMessageTime,
      );
    }
  }

  geoLocationCallback = (position) => {
    if (!!position) {
      let location = {};
      const guestGeolocation = getItem(storageTypes.localStorage, 'geoLocation');
      const guestLocation = getItem(storageTypes.localStorage, 'guestLocation');
      const guestLoginData = JSON.parse(localStorage.getItem('GuestLoginData'));
      const guestId = get(guestLoginData, 'id', '');
      const timeStamp = get(guestLocation, 'timeStamp', '');
      const differenceInTimeStamps = (Date.now() - timeStamp) / 60000; // divided by 60000 to convert it into minutes
      const latitude1 = get(
        guestGeolocation,
        'latitude',
        get(guestLocation, 'city.defaultLatitude'),
      );
      const longitude1 = get(
        guestGeolocation,
        'longitude',
        get(guestLocation, 'city.defaultLongitude'),
      );
      const latitude2 = position.coords && position.coords.latitude; // current coordiantes from geoLocationAPI
      const longitude2 = position.coords && position.coords.longitude; // current coordiantes from geoLocationAPI
      // set the current detected coordinates into location object and then into localStorage
      location['latitude'] = latitude2;
      location['longitude'] = longitude2;
      setItem(storageTypes.localStorage, 'geoLocation', location);

      const distance = checkDistanceBetweenCoordinates({
        latitude1,
        longitude1,
        latitude2,
        longitude2,
      });
      if (
        !isEmpty(guestId) &&
        (isEmpty(guestLocation) ||
          differenceInTimeStamps > geoLocationConfig.maxDifferenceBetweenTimeStamps ||
          distance > geoLocationConfig.maxDistanceInKm)
      ) {
        this.props.findGuestLocationAction({ guestId }); // find guest location if geo locatin coordinates are present
      }
    } else {
      this.props.findGeoLocationAction(); // find coordinates through google geolocation api
    }
  };

  checkGeoLocationPermission = () => {
    navigator.geolocation.getCurrentPosition(
      () =>
        this.setState({
          geoLocationPermissionStatus: permissionStatus.allow,
          trackAnalyticEvent: true,
        }),
      () =>
        this.setState({
          geoLocationPermissionStatus: permissionStatus.block,
          trackAnalyticEvent: true,
        }),
    );
  };

  handleMenuClick = () => {
    const { visible } = this.state;
    this.setState({
      visible: !visible,
    });
  };

  handleTrueCallerSignIn = ({ requestId }) => {
    this.props.beginAjaxCallAction();
    this.props.signInByTrueCallerAction({ requestId }).then((response) => {
      if (apiResponseCodes.SUCCESS.includes(get(response, 'status'))) {
        const guestLoginData = get(response, 'data', {});
        this.setState(
          {
            toast: constants.authentication.toastMessage.successfulLogin,
          },
          () => {
            this.props.dispatchGuestLoginDataAction(guestLoginData);
            this.props.endAjaxCallAction();
          },
        );
      } else {
        const code = get(response, 'data.code', '');
        const message = toTitleCase(get(response, 'data.message', ''));
        if (
          isEqual(code, authenticationConfig.userRejected) ||
          isEqual(code, authenticationConfig.trueCallerTimeout) ||
          isEqual(code, authenticationConfig.trueCallerRequestError)
        ) {
          let errorContent = getTrueCallerErrorContent({
            code,
            message,
          });
          this.setState(
            {
              showErrorPopup: true,
              errorContent,
              errorCode: code,
            },
            () => {
              this.props.endAjaxCallAction();
            },
          );
        } else if (isEqual(code, authenticationConfig.requestIdNotFound)) {
          // Again hit the true caller sing in handler
          this.handleTrueCallerSignIn({ requestId });
        } else {
          this.setState(
            {
              showAuthenticationPopup: true,
            },
            () => {
              this.props.endAjaxCallAction();
            },
          );
        }
      }
    });
  };

  handleLoginClick = () => {
    const { appSettings, restaurantConfigAdditionalProps } = this.props;
    // first check at restaurant level then check at app level
    const isTrueCallerEnabled = get(
      restaurantConfigAdditionalProps.find((prop) => get(prop, 'code') === 'tc.isEnabled'),
      'value',
      get(appSettings, 'tc.isEnabled', 'false'),
    );
    if (JSON.parse(isTrueCallerEnabled) && !isIOS()) {
      const requestId = generateUUID();
      const trueCallerDeeplink = getTrueCallerDeepLink({ requestId });
      window.location = trueCallerDeeplink;
      setTimeout(() => {
        if (document.hasFocus()) {
          // Truecaller app not present on the device and you redirect the user the regular otp flow
          this.setState({
            showAuthenticationPopup: true,
            visible: false,
          });
        } else {
          // Truecaller app present on the device and the profile overlay opens
          this.setState(
            {
              visible: false,
            },
            () => {
              this.handleTrueCallerSignIn({ requestId });
            },
          );
        }
      }, 600);
    } else {
      this.setState({
        showAuthenticationPopup: true,
        visible: false,
      });
    }
  };

  handleTrueCallerExceptionCTA = () => {
    this.setState({
      showErrorPopup: false,
      errorContent: {
        title: '',
        description: '',
        buttonCta: '',
      },
    });
    this.handleLoginClick();
  };

  onCloseAuthenticationPopup = () => {
    this.setState({
      showAuthenticationPopup: false,
    });
  };

  onHide = () =>
    this.setState({
      visible: false,
    });

  redirectToOrderList = () => {
    this.props.history.push(routes.containers.orders);
  };

  redirectToGuestCashCardList = () => {
    const { history } = this.props;
    history && history.push(`/${routes.containers.cashCards}`);
  };

  redirectToAboutFudr = () => {
    this.props.history.push(routes.containers.aboutFudr);
  };

  redirectToAccount = () => {
    this.props.history.push(routes.containers.account);
  };

  // redirectToHelpAndSupport = () => {
  //   this.props.history.push(`/${routes.containers.helpAndSupport}`);
  // }

  handleTabChange = (selectedTab) => {
    const { guestLocation, loginData } = this.props;
    const guestId = get(loginData, 'id', '');
    let fetchRestaurantListReqBody = {
      serviceType: getServiceTypeCode({ selectedTab }),
      isDefaultLocation: true,
      city: guestLocation,
      includeActiveOfferCount: true,
    };
    if (!isEmpty(guestId)) {
      fetchRestaurantListReqBody['guestId'] = guestId;
    }
    this.setState(
      {
        activeTab: selectedTab,
        restaurantList: [],
      },
      () => {
        if (isEqual(selectedTab, 'self-pickup') || isEqual(selectedTab, 'delivery')) {
          this.props.fetchRestaurantListAction({ fetchRestaurantListReqBody }).then(() => {
            this.setState({
              restaurantList: this.props.restaurantList,
            });
          });
        }
      },
    );
  };

  // logic for search
  handleSearchChange = (event) => {
    const { value } = event.target;
    const { restaurantList } = this.props;
    let updatedRestaurantList = cloneDeep(restaurantList);
    let sValue = toLower(value); // modified the user search input to the generic form
    let result = !isEmpty(sValue)
      ? updatedRestaurantList.filter((restaurant) => {
          let found = false;
          if (toLower(restaurant.name).includes(sValue)) {
            found = true;
          }
          return found ? restaurant : null;
        })
      : restaurantList;
    if (!isEmpty(result)) {
      this.setState({
        restaurantList: result,
        searchValue: value,
      });
    } else {
      this.setState({
        restaurantList: result,
        searchValue: value,
      });
    }
  };

  clearSearch = () => {
    this.setState({
      searchValue: '',
      restaurantList: this.props.restaurantList,
    });
  };

  handleRestaurantSelect = (restaurant) => {
    const { defaultScanCode } = restaurant;
    this.props.history.push(`/${routes.containers.welcome}/${defaultScanCode}`);
  };

  handleCityDropDownChange = () => {
    this.setState({
      showSelectCityPopup: true,
    });
  };

  onCloseSelectCityPopup = () => {
    this.setState({
      showSelectCityPopup: false,
    });
  };

  getSelectedCityOption = (selectedCity) => {
    let cityDropDownOption = [];
    cityDropDownOption.push({ key: selectedCity, text: selectedCity, value: selectedCity });
    return cityDropDownOption;
  };

  handleSelectCityClick = (city) => {
    const { activeTab: selectedTab } = this.state;
    let fetchRestaurantListReqBody = {
      serviceType: getServiceTypeCode({ selectedTab }),
      isDefaultLocation: true,
      city: city.name,
      includeActiveOfferCount: true,
    };
    const { loginData } = this.props;
    const guestId = get(loginData, 'id', '');
    if (!isEmpty(guestId)) {
      fetchRestaurantListReqBody['guestId'] = guestId;
    }
    this.setState({
      showSelectCityPopup: false,
      selectedCity: city.name,
    });
    this.props.dispatchGuestLocationAction(city.name).then(() => {
      this.props.fetchRestaurantListAction({ fetchRestaurantListReqBody }).then(() => {
        this.setState({
          restaurantList: this.props.restaurantList,
        });
      });
    });
  };

  handleTellUsClick = () => {
    this.setState({
      showSelectCityPopup: false,
      showTellUsPopup: true,
    });
  };

  onCloseTellUsPopup = () => {
    this.setState({
      showTellUsPopup: false,
    });
  };

  handleChangeLocationClick = () => {
    this.setState({
      showTellUsPopup: false,
      showSelectCityPopup: true,
    });
  };

  handleScanQRClick = () => {
    this.setState({
      showScanQRComponent: true,
    });
  };

  handleCloseScanQR = () => {
    this.setState({
      showScanQRComponent: false,
    });
  };

  onCloseExceptionComponent = () => {
    this.setState({
      showErrorPopup: false,
      errorContent: {
        title: '',
        description: '',
        buttonCta: '',
      },
      handleErrorCTA: null,
    });
  };

  handleExceptionCTA = () => {
    if (isEqual(get(this.state, 'errorCode', ''), authenticationConfig.userRejected)) {
      this.handleTrueCallerExceptionCTA();
      return;
    }
    this.setState({
      showErrorPopup: false,
      showAuthenticationPopup: true,
    });
  };

  handleStopTracking = () => {
    this.setState({ trackAnalyticEvent: false });
  };

  render() {
    const {
      banner,
      visible,
      showAuthenticationPopup,
      showSelectCityPopup,
      showTellUsPopup,
      activeTab,
      restaurantList,
      searchValue,
      selectedCity,
      showScanQRComponent,
      showErrorPopup,
      errorContent,
      toast,
      trackAnalyticEvent,
      geoLocationPermissionStatus,
    } = this.state;
    const { history, restaurantList: availableRestaurantList, showCashCardFeature } = this.props;
    const sortedRestaurantlist =
      restaurantList &&
      restaurantList.length > 0 &&
      orderBy(restaurantList, 'restaurantConfig.mode', 'ACTIVE');
    return (
      <div className="scan">
        <Banner
          className="scan_business_banner"
          position={banner.position}
          color={banner.color}
          message={
            <span>
              {constants.scanCode.lookingToKnowAboutFudr}
              <a href={businessWebsiteUrl} target="_blank" rel="noopener">
                {constants.scanCode.visitOurBusinessSite}
              </a>
            </span>
          }
        />
        {
          <div className="scan_hamburger-Btn">
            <Button
              content={
                !visible ? (
                  <img alt="HamburgerIcon" src={hamburgerIcon} />
                ) : (
                  <img alt="closeIcon" src={closeIcon} />
                )
              }
              onClick={this.handleMenuClick.bind(this)}
            />
          </div>
        }
        {/* Logic for Side bar Menu */}
        {visible && (
          <Drawer
            identifier={routes.containers.scan}
            visible={visible}
            onHide={this.onHide}
            onLogin={this.handleLoginClick.bind(this)}
            handleMenuClick={this.handleMenuClick.bind(this)}
            redirectToOrderList={this.redirectToOrderList.bind(this)}
            redirectToGuestCashCardList={this.redirectToGuestCashCardList}
            history={history}
            redirectToAboutFudr={this.redirectToAboutFudr.bind(this)}
            redirectToAccount={this.redirectToAccount.bind(this)}
            // redirectToHelpAndSupport={this.redirectToHelpAndSupport.bind(this)}
            showCashCardFeatureOnScanScreen={showCashCardFeature}
          />
        )}
        <Sidebar.Pushable onClick={this.onHide}>
          <Sidebar.Pusher dimmed={visible}>
            <div className="scan_qrScannerWindow">
              {!isEmpty(toast) && <Toast content={toast} />}
              <div className="scan_fudr-section">
                <div className="scan_fudrLogo">
                  <img alt="FUDR" src={fudrIcon} />
                </div>
                {/* <Tabs active={activeTab} handleTabChange={this.handleTabChange.bind(this)} /> */}
              </div>
              {isEqual(activeTab, 'scan-qr') && (
                <div className="scan_scan-qr-section" onClick={this.handleScanQRClick}>
                  <div className="fudrScanImage">
                    <img src={scanImageIcon} alt="scan" />
                  </div>
                  <div className="fudrScanBtn">
                    <Button
                      name="scan"
                      onClick={this.handleScanQRClick}
                      content={constants.scanCode.scanText}
                    />
                  </div>
                </div>
              )}
              {(isEqual(activeTab, 'self-pickup') || isEqual(activeTab, 'delivery')) && (
                <div className="scan_other-services-section">
                  <div className="city-dropdown">
                    <DropDown
                      open={false}
                      name="city"
                      value={selectedCity}
                      defaultValue={selectedCity}
                      options={this.getSelectedCityOption(selectedCity)}
                      onClick={this.handleCityDropDownChange}
                    />
                  </div>
                  {!isEmpty(availableRestaurantList) && (
                    <span className="search-section">
                      <Search
                        handleSearchChange={this.handleSearchChange}
                        clearSearch={this.clearSearch}
                        searchValue={searchValue}
                        placeholder={constants.search.placeHolder.selfPickup}
                      />
                    </span>
                  )}
                  <div className="restaurant-list-section">
                    {!isEmpty(availableRestaurantList) ? (
                      <RestaurantList
                        restaurantList={sortedRestaurantlist}
                        handleRestaurantSelect={(restaurant) =>
                          this.handleRestaurantSelect(restaurant)
                        }
                        serviceType={activeTab}
                      />
                    ) : (
                      <div className="scan_no-restaurant-available">
                        <span className="text">
                          {constants.selfPickup.description1}
                          <span className="tell-us" onClick={this.handleTellUsClick}>
                            {constants.selfPickup.tellUsText}
                          </span>
                          {constants.selfPickup.description3}
                        </span>
                        <span className="change-location">
                          <Button
                            name="changeLocation"
                            onClick={this.handleChangeLocationClick}
                            content={constants.selfPickup.restaurantList.changeLocation}
                          />
                        </span>
                      </div>
                    )}
                  </div>
                  {!isEmpty(availableRestaurantList) && (
                    <span className="scan_unable-to-locate-restaurant">
                      {constants.selfPickup.description2}{' '}
                      <a onClick={this.handleTellUsClick}>{constants.selfPickup.tellUsText}</a>{' '}
                      {constants.selfPickup.description3}
                    </span>
                  )}
                </div>
              )}
            </div>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
        {showAuthenticationPopup && (
          <AuthenticationPopup
            openSegmentPopup={showAuthenticationPopup}
            dismissSegmentPopup={this.onCloseAuthenticationPopup}
          />
        )}
        {showSelectCityPopup && (
          <SelectCityPopup
            openSegmentPopup={showSelectCityPopup}
            dismissSegmentPopup={this.onCloseSelectCityPopup}
            handleSelectCityClick={(city) => this.handleSelectCityClick(city)}
            handleTellUsClick={this.handleTellUsClick}
          />
        )}
        {showTellUsPopup && (
          <TellUsPopup
            openSegmentPopup={showTellUsPopup}
            dismissSegmentPopup={this.onCloseTellUsPopup}
          />
        )}
        {showScanQRComponent && (
          <ScanQR history={history} handleCloseScanQR={this.handleCloseScanQR} />
        )}
        {showErrorPopup && (
          <ExceptionComponent
            pageType="HalfSize"
            openSegmentPopup={showErrorPopup}
            dismissSegmentPopup={this.onCloseExceptionComponent}
            title={get(errorContent, 'title')}
            description={get(errorContent, 'description')}
            buttonCta={get(errorContent, 'buttonCta')}
            handleButtonCta={this.handleExceptionCTA}
          />
        )}
        {
          <PermissionEvent
            startTracking={trackAnalyticEvent}
            vendorType={analyticsVendorType.GTM}
            label={fudrAnalyticsGTMEventLabel.permission.location}
            action={fudrAnalyticsGTMEvents.permission}
            category={fudrAnalyticsGTMEventCategory.permission.user}
            permission={geoLocationPermissionStatus}
            handleStopTracking={this.handleStopTracking}
          />
        }
      </div>
    );
  }
}

export default connect(
  (state) => ({
    appSettings: get(state, 'app.masterData.appSettings', {}),
    menu: selectMenu(state),
    selectedTable: get(state, 'app.selectedTable', {}),
    restaurant: selectRestaurant(state),
    loginData: get(state, 'authentication.loginData', {}),
    restaurantList: get(state, 'app.restaurantList._embedded.restaurants', []),
    guestLocation: get(state, 'app.guestLocation.cityName', ''),
    restaurantGroup: get(state, 'app.restaurantGroup', {}),
    restaurantConfigAdditionalProps: get(
      state,
      'app.restaurant.restaurantConfig.additionalProperties',
      [],
    ),
  }),
  {
    invalidateRestaurantDataAction,
    clearViewCartItems,
    clearRequestedTimeStampAction,
    fetchRestaurantListAction,
    dispatchPreviousSelectedTableAction,
    dispatchVerifiedLocalitiesAction,
    dispatchSelectedAddressAction,
    dispatchGuestLocationAction,
    clearRestaurantGroupDataAction,
    dispatchParentRouteAction,
    signInByTrueCallerAction,
    dispatchGuestLoginDataAction,
    beginAjaxCallAction,
    endAjaxCallAction,
    dispatchUserCart: dispatchUserCartAction,
    findGuestLocationAction,
    findGeoLocationAction,
  },
)(Scan);
